module.exports = __webpack_public_path__ + "static/media/SWH_white_horizontal.c11351c0.png";